import {
  Button,
  Divider,
  Stack,
} from '@datanomik/commons-ui';
import {
  ContentCopyOutlined,
  EmailOutlined,
  QrCode2Outlined,
  WhatsApp,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { ExternalLinkLine } from '@datanomik/commons-ui/icons';
import { ActionRow } from '@/features/support/shared/action-row/ActionRow';
import CopyButton from '@/views/common/Copy/CopyButton';
import { useTranslation } from 'react-i18next';
import useUser from '@/hooks/useUser';
import { ZendeskIcon } from '@/features/support/shared/icons/ZendeskIcon';
import { useState } from 'react';
import { SupportPanelQRCode } from './SupportPanelQRCode';

const EMAIL = 'support@datanomik.com';
const BUILD_WHATSAPP_URL = (email: string) => `https://wa.me/15558088846?text=${encodeURIComponent(`Olá! Preciso de suporte. Meu email é ${email}`)}`;
const BUILD_ZENDESK_URL = (email: string) => `https://datanomiksupport.zendesk.com/hc/requests/new?tf_anonymous_requester_email=${email}`;

export function SupportPanelReportProblemChannelsArea() {
  const { t } = useTranslation();
  const { user: { email: userEmail = '' } } = useUser();
  const [showQRCode, setShowQRCode] = useState(false);

  return (
    <Box display="flex" flexDirection="column">

      <ActionRow
        color="grey"
        icon={<EmailOutlined />}
        title={t('Email')}
        subtitle={EMAIL}
        actions={[
          <CopyButton value={EMAIL}>
            <Button variant="outlined" color="black" size="small" startIcon={<ContentCopyOutlined />}>
              {t('Copy')}
            </Button>
          </CopyButton>,
        ]}
      />
      <Divider />
      <ActionRow
        color="gray"
        icon={<ZendeskIcon />}
        title={t('ZenDesk')}
        subtitle={t('Create and manage your tickets')}
        actions={[
          <Button
            variant="outlined"
            color="black"
            size="small"
            startIcon={<ExternalLinkLine />}
            onClick={() => window.open(
              BUILD_ZENDESK_URL(userEmail),
              '_blank',
            )}
          >
            {t('Open')}
          </Button>,
        ]}
      />
      <Divider />
      <Stack>
        <ActionRow
          color="gray"
          icon={<WhatsApp />}
          title={t('WhatsApp')}
          subtitle={t('Talk to support')}
          actions={[
            <Button
              variant="outlined"
              color="black"
              size="small"
              startIcon={<ExternalLinkLine />}
              onClick={() => window.open(
                BUILD_WHATSAPP_URL(userEmail),
                '_blank',
              )}
            >
              {t('Open in Web')}
            </Button>,
            <Button
              variant="outlined"
              color="black"
              size="small"
              onClick={() => {
                setShowQRCode(!showQRCode);
              }}
              startIcon={<QrCode2Outlined />}
            />,
          ]}
        />
        {showQRCode && (
          <SupportPanelQRCode value={BUILD_WHATSAPP_URL(userEmail)} />
        )}
      </Stack>
    </Box>
  );
}
